<template>
    <div>
        <forms
                :settings="settings"
                @onFormButtonClick="onFormButtonClick"
                @onInput="onInput"
        >
        </forms>
    </div>
</template>

<script>
import axios from "axios";
import toastr from 'toastr';
import Forms from "@/components/form/Forms";
export default {
    name: "SkupTema2Forma",
    components: { Forms },
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        id:{
            default: null
        },
        modal:{
            type: Boolean,
            default: false
        },
        action: {
            type: String
        }
    },
    data(){
        return {
            settings: {},
            errors: {},
            route: '/skupovi/' + this.$route.params.skup_id + '/teme',
            url: 'skup-tema',
            data: {},
            skup_id: this.$route.params.skup_id,

            dvorane_select: [],
            vidljiva_na_prijavi_select: []
        }
    },

    methods: {

        async fetchDvorane(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'dvorana', {
                params: {
                    paga: 1,
                    par_page: -1,
                    order: 'desc',
                    filters:{
                        skup_id: vm.skup_id
                    }
                }
            } )
            return response.data.data.map( function( item ) {
                vm.dvorane_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv
                    }
                )
            } )
        },

        getDvorana( id ){
            return this.dvorane_select.find( item => item.key === id )
        },

        async fetchVidljivaNaPrijavi(){
            this.vidljiva_na_prijavi_select = [
                {
                    key: '0',
                    value: 'Ne'
                },
                {
                    key: '1',
                    value: 'Da'
                }
            ]
        },

        getVidljivaNaPrijavi( id ){
            return this.vidljiva_na_prijavi_select.find( item => item.key === id )
        },

        async init(){
            let vm = this

            await vm.fetchDvorane()
            await vm.fetchVidljivaNaPrijavi()

            if ( vm.action === 'edit' || vm.action === 'show' ){

                axios.get( process.env.VUE_APP_API_URL + vm.url + '/' + vm.id )
                        .then( function ( response ) {

                            vm.data.skup_id = response.data.skup_id.toString()
                            vm.data.izzy_edu_id = response.data.izzy_edu_id ? response.data.izzy_edu_id.toString() : ''
                            vm.data.broj_teme = response.data.broj_teme
                            vm.data.naziv = response.data.naziv
                            vm.data.datum_od = response.data.datum_od
                            vm.data.datum_do = response.data.datum_do
                            vm.data.predavaci = response.data.predavaci
                            vm.data.dvorana_id = response.data.dvorana_id ? response.data.dvorana_id.toString() : ''
                            vm.data.vidljiva_na_prijavi = response.data.vidljiva_na_prijavi.toString()

                            vm.$emit( 'returnData', response.data )
                            vm.setupForm()
                        } )
                        .catch( function ( error ) {
                            if(error instanceof Error) {
                                console.log( 'Error: ' . error);
                            } else {
                                console.log( 'Unexpected response: ' . error);
                            }
                        } )

            } else if ( vm.action === 'create' ) {
                vm.data = {}
                vm.data.skup_id = vm.skup_id
                vm.data.vidljiva_na_prijavi = '1'
                vm.setupForm()
            } else {
                return
            }
        },

        setupForm(){

            let vm = this;

            vm.buttons = []

            let button_cancel = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
                action: 'redirect', // request
                config: {
                    url: vm.route + ( vm.action === 'edit' ? ( '/' + vm.id) : '' )
                }
            }

            let button_delete = {
                id: 'delete',
                title: 'Obriši',
                type: 'danger',
                action: 'request',
                config: {
                    method: 'DELETE',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let button_edit = {
                id: 'edit',
                title: 'Uredi',
                type: 'success',
                action: 'redirect',
                config: {
                    url: vm.route +  '/' + vm.id +'/edit'
                }
            }

            let button_save = {
                id: 'save',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + vm.url
                }
            }

            let button_update = {
                id: 'update',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'PUT',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let buttons = []


            if( vm.action === 'edit' ){
                buttons.push( button_cancel)
                buttons.push( button_update)
            } else if( vm.action === 'show' ) {
                buttons.push( button_cancel )
                buttons.push( button_delete )
                buttons.push( button_edit )
            }
            else if ( vm.action === 'create' ) {
                buttons.push( button_cancel )
                buttons.push( button_save )
            } else {
                return
            }


            let skup_id_input = {
                name: 'skup_id',
                type: 'hidden',
                value: vm.data.skup_id,
                disabled: vm.disabled,
                config: {
                    hidden:true
                }
            }

            let izzy_edu_id_input = {
                name: 'izzy_edu_id',
                type: 'hidden',
                value: vm.data.izzy_edu_id,
                disabled: vm.disabled,
                config: {
                    hidden:true
                }
            }

            let broj_teme_input = {
                name: 'broj_teme',
                type: 'input',
                title: 'Broj teme',
                value: vm.data['broj_teme'],
                width: 12,
                error: vm.errors['broj_teme'] ? vm.errors['broj_teme'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
            }

            let naziv_input = {
                name: 'naziv',
                type: 'input',
                title: 'Naziv',
                value: vm.data['naziv'],
                width: 12,
                error: vm.errors['naziv'] ? vm.errors['naziv'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
            }

            let datum_od_input = {
                name: 'datum_od',
                type: 'datepicker',
                title: 'Početak događaja',
                value: vm.data['datum_od'],
                width: 12,
                error: vm.errors['datum_od'] ? vm.errors['datum_od'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    mode:'dateTime',
                    title_width: 4,
                    input_width: 4
                }
            }

            let datum_do_input = {
                name: 'datum_do',
                type: 'datepicker',
                title: 'Završetak događaja',
                value: vm.data['datum_do'],
                width: 12,
                error: vm.errors['datum_do'] ? vm.errors['datum_do'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    mode:'dateTime',
                    title_width: 4,
                    input_width: 4
                }
            }

            let predavaci_input = {
                name: 'predavaci',
                type: 'input',
                title: 'Predavači',
                value: vm.data['predavaci'],
                width: 12,
                error: vm.errors['predavaci'] ? vm.errors['predavaci'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
            }

            let dvorana_id_input = {
                name: 'dvorana_id',
                type: 'select',
                title: 'Dvorana',
                value: vm.getDvorana( vm.data.dvorana_id ),
                width: 12,
                error: vm.errors['dvorana_id'] ? vm.errors['dvorana_id'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.dvorane_select,
                }
            }

            let vidljiva_na_prijavi_input = {
                name: 'vidljiva_na_prijavi',
                type: 'select',
                title: 'Vidljiva na prijavi',
                value: vm.getVidljivaNaPrijavi( vm.data.vidljiva_na_prijavi ),
                width: 12,
                error: vm.errors['vidljiva_na_prijavi'] ? vm.errors['vidljiva_na_prijavi'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: !vm.disabled,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.vidljiva_na_prijavi_select,
                }
            }

            let inputs = []
            inputs.push(skup_id_input)
            inputs.push(izzy_edu_id_input)
            inputs.push(broj_teme_input)
            inputs.push(naziv_input)
            inputs.push(datum_od_input)
            inputs.push(datum_do_input)
            inputs.push(predavaci_input)
            inputs.push(dvorana_id_input)
            inputs.push(vidljiva_na_prijavi_input)

            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: [
                            {
                                name: '',
                                width: 12,
                                inputs: inputs,
                            }
                        ],
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },

        /**
         *  on input return data
         */
        onInput( name, value ){
            let vm = this
            if( vm.data[name] !== value ){
                vm.data[name] = value
                vm.setupForm()
            }
        },

        /**
         *  on button click
         */
        onFormButtonClick( id, action, config, data  ){

            if( id === 'save' || id === 'update' ){
                if( data.success){
                    if( id == 'save' )
                        toastr.success( 'Uspješno spremljeno!' )
                    else if ( id == 'update' )
                        toastr.success( 'Uspješno ažurirano!' )
                    this.$router.push({ path: this.route + '/' + data.data.id } )
                } else {
                    this.errors = data.messages
                    this.setupForm()
                }
            } else if( id == 'delete' ){
                toastr.error( 'Uspješno obrisano!' )
                this.$router.push({ path: this.route } )
            }

        },
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>
